import { toast } from "react-toastify";
import { useTemplateContext } from "./TemplateContext";
import { useCreateTemplate } from "./templates";
import { useQueryClient } from "react-query";
import { FormButton } from "../../atoms";

type CreateNewButtonProps = {
  onComplete?: () => void;
  isLoading?: boolean;
};
export const CreateNewButton = ({ onComplete = () => {}, isLoading }: CreateNewButtonProps) => {
  const {
    state: { template },
  } = useTemplateContext();

  return <FormButton disabled={!template?.id} loading={isLoading} label="Save as New Template" color="success" fullWidth onClick={onComplete} />;
};
